import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-row",
    templateUrl: "./row.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./row.component.scss"]
})
export class RowComponent {
}
